// extracted by mini-css-extract-plugin
export default {"waves":"style_waves__9Qc5e","check":"style_check__gJ7zr","title":"style_title__X50k1","back":"style_back__NRdfi"};